import htmlComponent from 'htmlcomponent'

export default function(dom, opts) {
    console.log("in teamlist!");

    dom
        .querySelectorAll('input[name="filters"]')
        .forEach(checkbox => {
            checkbox.addEventListener('change', filterTeamMembers);
        });

    function filterTeamMembers() {
        const teamMembers = dom.querySelectorAll('.team-element__member');
        const headings = dom.querySelectorAll('.team-element__headline');

        const selectedValues = Array.from(
            dom.querySelectorAll('input[name="filters"]:checked')
        ).map(checkbox => checkbox.value);

        let hasActiveFilters = selectedValues.length > 0;

        // Verwende Set, um Duplikate zu vermeiden
        const displayedMembers = new Set();

        console.log("Selected filters: ", selectedValues); // Logge die ausgewählten Filter-Werte

        teamMembers.forEach(member => {
            const memberId = member.getAttribute('data-id'); // Hole die ID des Teammitglieds
            const filterValuesAttr = member.getAttribute('data-departments');

            console.log("Member ID:", memberId, "Departments:", filterValuesAttr); // Logge ID und Abteilungen

            if (filterValuesAttr) {
                const filterValues = filterValuesAttr.split(',');

                // Zeige das Teammitglied nur an, wenn es zu einem der ausgewählten Filter gehört
                if (hasActiveFilters && selectedValues.some(value => filterValues.includes(value))) {
                    // Nur anzeigen, wenn dieses Teammitglied noch nicht angezeigt wurde
                    if (!displayedMembers.has(memberId)) {
											displayedMembers.add(memberId);
											member.style.display = 'block';
										} else {
											member.style.display = 'none';
										}
                } else {
                    member.style.display = hasActiveFilters ? 'none' : 'block'; // Alles anzeigen, wenn keine Filter aktiv sind
                }
            } else {
                // Falls `data-departments` null ist, kannst du hier entscheiden, was zu tun ist
                member.style.display = hasActiveFilters ? 'none' : 'block'; // Verstecke es, wenn Filter aktiv sind
            }
        });

        // Überschriften ausblenden, wenn Filter aktiv sind, andernfalls anzeigen
        headings.forEach(heading => {
            heading.style.display = hasActiveFilters ? 'none' : 'block'; // Alles anzeigen, wenn keine Filter aktiv sind
        });
    }
}
